import { createTelemetry, createTelemetryObject } from '@shared/core/analytics';
import type { PageFunctionType } from '@shared/core/analytics/telemetry/types';

const pagePrefix = 'admin.registry';

export type PagesForTelemetry =
  | 'delayShippingEnableDialog'
  | 'delayShippingDisableDialog'
  | 'shipNowOrderConfirmationDialog'
  | 'shipAllOrdersConfirmationDialog'
  | 'shippingAddressConflictConfirmationDialog';

const pages: { [tab in PagesForTelemetry]: PageFunctionType } = {
  delayShippingEnableDialog: () => ({
    category: 'delayShipping',
    pagePrefix,
    page: 'EnableConfirmationDialog',
  }),
  delayShippingDisableDialog: () => ({
    category: 'delayShipping',
    pagePrefix,
    page: 'DisableConfirmationDialog',
  }),
  shipNowOrderConfirmationDialog: () => ({
    category: 'tracker',
    pagePrefix,
    page: 'ShipNowOrderConfirmationDialog',
  }),
  shipAllOrdersConfirmationDialog: () => ({
    category: 'tracker',
    pagePrefix,
    page: 'ShipAllOrdersConfirmationDialog',
  }),
  shippingAddressConflictConfirmationDialog: () => ({
    category: 'delayShipping',
    pagePrefix,
    page: 'ShippingAddressConflictConfirmationDialog',
  }),
};

export const delayShippingTelemetry = createTelemetryObject({
  actions: {
    toggleDelayShippingClicked: () => ({
      pagePrefix,
      category: 'delayShipping',
      action: 'ButtonInteracted',
      label: 'Delay shipping',
    }),
    toggleDelayShippingConfirmClicked: (toggle: 'enable' | 'disable') => ({
      pagePrefix,
      category: 'delayShipping',
      action: 'ButtonInteracted',
      label: 'Got it',
      extraInfo: {
        onChangeAction: toggle,
      },
    }),
    shipNowConfirmationClicked: (orderId: string) => ({
      pagePrefix,
      category: 'tracker',
      action: 'ButtonInteracted',
      label: 'Ship Order Now',
      extraInfo: {
        orderId,
      },
    }),
    shipNowClicked: (orderId: string) => ({
      pagePrefix,
      category: 'tracker',
      action: 'ButtonInteracted',
      label: 'Ship Order Now',
      extraInfo: {
        orderId,
      },
    }),
    shipAllOrdersConfirmationClicked: (orderIds: string[], shippingAddressUpdate?: boolean) => ({
      pagePrefix,
      category: 'tracker',
      action: 'ButtonInteracted',
      label: 'Ship All Orders',
      extraInfo: {
        orderIds,
        ordersCount: orderIds.length,
        shippingAddressUpdate,
      },
    }),
    reviewAndShipAllOrdersClicked: () => ({
      pagePrefix,
      category: 'tracker',
      action: 'ButtonInteracted',
      label: 'Review And Ship All Orders',
    }),
    newShippingAddressClicked: (shippingAddressUpdate: boolean) => ({
      pagePrefix,
      category: 'delayShipping',
      action: 'ButtonInteracted',
      label: 'NewShippingAddress',
      actionType: 'click',
      extraInfo: {
        shippingAddressUpdate,
      },
    }),
    delayShippingMutationError: (errorMessage: string) => ({
      pagePrefix,
      category: 'delayShipping',
      action: 'Mutation',
      actionType: 'error',
      extraInfo: {
        errorMessage,
      },
    }),
  },
  pages,
});

export const { TelemetryProvider, useTelemetry: useDelayShippingTelemetry } = createTelemetry(delayShippingTelemetry, { eventId: '' });
